export default {
  'app.actions.enter': 'Entrar',
  'app.actions.back': 'Voltar',
  'app.actions.download': 'Baixar PDF',

  'app.home.header': 'Planta Baixa Futurecom 2018',
  'app.home.paragraph': 'Lorem ipsum sit a merd dolor inpregnantis.',

  'app.header.reset': 'Recuperar Senha',
  'app.header.createPassword': 'Criar nova senha',

  'app.error': 'Erro',
  'app.error.token': 'O link está errado ou já expirou.',
  'app.success.reset': 'A nova senha foi alterada com sucesso.',

  'app.label.name': 'Nome',
  'app.label.email': 'Email',
  'app.label.password': 'Nova senha',
  'app.label.confirmation': 'Confirme a nova senha',
};



/** WEBPACK FOOTER **
 ** ./src/app/intl/pt.js
 **/